<div class="tile__status tile__status--default" data-testid="alarm-tile">
    <svg width="50" height="50" class="tile__svg--alarm tile__svg-fill"
        *ngIf="tile.alarmType !== 'notification'"
        [ngClass]="{ 'tile__svg--alarm-animation' : tile.alarmType === 'alarm',
            'tile__svg-fill': tile.alarmType === 'warning' }">
        <text x="25" y="45" font-size="65" font-weight="bold" text-anchor="middle">!</text>
    </svg>
    <div class="tile__svg--other-wrapper bg-img"
        *ngIf="tile.alarmType === 'notification'">
        <img class="tile__svg--other" ngSrc="/assets/img/id_icons/29.svg"
             width="50" height="50" alt="" />
    </div>
    <div class="tile__subtitle tile__subtitle--flex">
        <div [ngSwitch]="tile.alarmType" class="tile__title-test-row">
            <p *ngSwitchCase="'alarm'"
               class="tile__alarm--header color-basic font-bold">
               {{ subtitle(65) }}
            </p>
            <p *ngSwitchCase="'warning'"
               class="tile__alarm--header color-basic font-bold">
               {{ subtitle(1063) }}
            </p>
            <p *ngSwitchCase="'notification'"
               class="tile__alarm--header color-basic font-bold">
               {{ subtitle(1767) }}
            </p>
        </div>
        <floating-subtitle class="tile__title-test-row"
            *ngIf="tile.unit === '' || tile.unit === 0"
            [text]="formatAlarmText(tile)">
        </floating-subtitle>
        <floating-subtitle class="tile__title-test-row"
            *ngIf="tile.value !== '' && tile.unit !== '' && tile.unit > 0"
            [text]="subtitle(tile.txtId) + (tile.unit == 35
                ? ' [' + subtitle(1219) + ': ' + ('0' + (tile.value | format:tile.unit)).slice(-2) + ']'
                : ' ' + (tile.value | format:tile.unit))">
        </floating-subtitle>
        <p class="tile__title-test-row font-12 color-default"
           *ngIf="subtitles.downloaded">

            {{ tile.time | format:24 }}
        </p>
    </div>
    <div class="tile__setting cursor-pointer"
        [ngClass]="{ 'bg-light-shadow': tile.elementMenu.duringChange === 't' }"
        *ngIf="tile.elementMenu && tile.menuId !== 0"
        (click)="goControl()">
        <img ngSrc="/assets/img/icons/{{ getIconName() }}.svg"
             width="30" height="30" alt="" />
        <p class="tile__setting-alert font-12 color-light"
           *ngIf="tile.elementMenu.duringChange == 't'">
            {{ subtitle(3162) }}
        </p>
    </div>
</div>
